import { NavbarService } from './../../services/navbar-service.service';
import { Router } from '@angular/router';
import { AuthService } from './../../services/auth.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit, OnDestroy {

  private subscription: ISubscription;

  constructor(public auth: AuthService, public router: Router, public navbarService: NavbarService) { }

  navTab = 'profile';
  viewMode = 'overview';

  /* emailControl = new FormControl('', [Validators.required, Validators.email]);

  emailForm = new FormGroup({
    email: this.emailControl,
    password: new FormControl()
  }); */

  ngOnInit() {
    this.subscription = this.auth.user$.subscribe(user => {
      if (!user) {
        this.navbarService.show();
        this.router.navigateByUrl('/login');
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/magnustrandokken/Desktop/Magson/Web/Foko/foko-angular/src/app/ui/profile/profile.component.ts